export default "__VITE_ASSET__boffcoTu__"